<template>
  <div>
    <list-vue
      v-bind:busqueda="busqueda"
      v-bind:busquedaTraduccion="busquedaTraduccion"
      v-bind:busquedaMedidas="busquedaMedidas"
      v-bind:opciones="opciones"
      v-bind:moduloTitulo="moduloTitulo"
      v-bind:pantallaTitulo="pantallaTitulo"
      v-bind:rutaConsulta="rutaConsulta"
      v-bind:buttonsPage="buttonsPage"
      v-bind:busquedaCampos="busquedaCampos"
    ></list-vue>
  </div>
</template>
  <script type="text/javascript">
import { mapState } from "vuex";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      //Definimos los nombres generales
      moduloTitulo: this.$root.trans(
        "Tabla de Datos para Tablas en Campos Adicionales"
      ),
      reporte: false,
      pantallaTitulo: this.$root.trans("Resultado"),
      rutaConsulta: this.$route.fullPath,
      buttonsPage: [
        {
          type: "button",
          class: "btn btn-xs btn-info pull-right",
          route: "AuthorsCreate",
          text: '<i class="fa fa-plus">',
          external: "../../../../../tablacamposdatos.php?filtroTipoNC=RE",
        },
      ],
      //Definimos los campos de busqueda, sus nombres e incluso tamaño
      busqueda: {
        orden_nro: "",
        descripcion: "",
        tipo_dato: "",
        marca_obliga: "",
        nro_campo: "",
        etapa_codi: "",
        tipo_nc_codi: "",
        estado: "",
      },
      busquedaTraduccion: {
        orden_nro: this.$root.trans("Orden"),
        descripcion: this.$root.trans("Descripción"),
        marca_texto_otras: this.$root.trans("Marca Otras."),
        marca_finaliza_ficha: this.$root.trans("Obliga Finalizar."),
        nro_campo: this.$root.trans("Campo"),
        etapa_codi: this.$root.trans("Etapa"),
        tipo_nc_codi: this.$root.trans("Tipo"),
        estado: this.$root.trans("Estado"),
      },
      busquedaCampos: {
        estado: {
          type: "select",
          options: [
            { label: "Activo", code: "A" },
            { label: "Desactivado", code: "B" },
          ],
        },
        nro_campo: {
          type: "select",
          options: [],
        },
        etapa_codi: {
          type: "select",
          options: [],
        },
        tipo_nc_codi: {
          type: "select",
          options: [],
        },
        marca_finaliza_ficha: {
          type: "select",
          options: [
            { code: "S", label: "Si" },
            { code: "N", label: "No" },
          ],
        },
        marca_texto_otras: {
          type: "select",
          options: [
            { code: "S", label: "Si" },
            { code: "N", label: "No" },
          ],
        },
      },
      busquedaMedidas: {
        orden_nro: "80px",
        descripcion: "",
        horas_resoluc_defecto: "80px",
        tipo_dato: "130px",
        marca_finaliza_ficha: "180px",
        marca_texto_otras: "180px",
        etapa_codi: "180px",
        tipo_nc_codi: "180px",
        estado: "130px",
      },
      //definimos las opciones con enlace simple para ello usamos el nombre de la ruta y en caso de eliminar usamos la ruta
      opciones: [
        // {
        //   class: "btn btn-sm btn-warning",
        //   icon: "fas fa-edit",
        //   routerName: "TiposRegistroEdit",
        //   param: "codigo",
        //   eliminar: false,
        //   nombre: "Editar",
        // },
      ],
    };
  },
  computed: {
    ...mapState(["request"]),
  },
  methods: {
    ...mapMutations({ requestSet: "request" }),
  },
  mounted() {
    this.requestSet(this.$route.query);
  },
  created() {
    this.requestSet(this.$route.query);

    const data = {
      selects: {
        // User: {},
        TipoNC: { categoria_nc: "RE", estado: "all" },
        generic1: {
          code: "descripcion",
          label: "descripcion",
          model: "FichasEtapaNC",
          order: "descripcion",
          nc: "RE",
        },
        generic2: {
          code: "descripcion",
          label: "descripcion",
          model: "EtapaCamposAdicionales",
          order: "descripcion",
          nc: "RE",
        },
      },
    };
    this.$root
      .Consulta(
        this.$root.UrlBase("selects/init"),
        data,
        "post",
        false,
        false,
        false,
        "",
        false
      )
      .then((response) => {
        this.busquedaCampos.tipo_nc_codi.options = response.TipoNC;
        this.busquedaCampos.etapa_codi.options = response.generic1;
        this.busquedaCampos.nro_campo.options = response.generic2;
      });
  },
};
</script>
